var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDesign = function SvgDesign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#design_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 13.416a3.5 3.5 0 1 1-1.355-1.473l5.6-5.6c.035-1.149.128-3.631.128-3.631l-13.338 3.73a.948.948 0 0 0-.624.56l-3.618 9.015 9.192 9.192 9.005-3.613a.945.945 0 0 0 .564-.643l3.43-13.302-3.323.104L20 13.416Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.388 15.183c.74-.74 1.94-.74 2.68 0l10.681 10.68a2 2 0 0 1 0 2.829l-2.4 2.4a2 2 0 0 1-2.828 0L.841 20.412A1.897 1.897 0 0 1 .84 17.73l2.547-2.548Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    d: "M24.283 2.819a1 1 0 0 1 1-1.02h3.98a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-3.905a1 1 0 0 1-1-.98l-.075-4Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "design_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgDesign;